import { render, staticRenderFns } from "./origen.vue?vue&type=template&id=d68723d2&"
import script from "./origen.vue?vue&type=script&lang=js&"
export * from "./origen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports